module.exports = __webpack_public_path__ + "img/Persepsi-Label0.94fb3eb3.png";